import { render, staticRenderFns } from "./GRCControlsList.vue?vue&type=template&id=d7d4be80&scoped=true&"
import script from "./GRCControlsList.vue?vue&type=script&lang=js&"
export * from "./GRCControlsList.vue?vue&type=script&lang=js&"
import style0 from "./GRCControlsList.vue?vue&type=style&index=0&id=d7d4be80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d4be80",
  null
  
)

export default component.exports